import {  BulkMessageData, useGetBulkMessageDetails } from "../../hooks/apis/bulkmessages.api";
import Table, { ColumnsType } from "antd/es/table";
import { formatPhoneNumber } from "../../utils/phoneLib";
import { Avatar, Flex, Popover, Tag, Tooltip, Typography } from "antd";
import phoneImg from "../../assets/images/icon/Phone-call.svg";
import dayjs from "dayjs";
import { FaCircleInfo } from "react-icons/fa6";
import { useEffect } from "react";

const avatarStyle: React.CSSProperties = {
    height: "1.2rem",
    width: "1.2rem",
    marginTop: "2px"
};

const BulkMessageStatusTable = ({ search, id }: { search: string; id: string }) => {
    const { data, isLoading } = useGetBulkMessageDetails(id as string);

    useEffect(() => {
        console.log("data", data);
    }, [data]);

    const columns: ColumnsType<BulkMessageData> = [
        {
            title: "Participant",
            dataIndex: "participant",
            key: "participant",
            align: "center",
            render: (_, { participant }) => (
                <Flex justify="center" gap={10}>
                    <Avatar style={avatarStyle} src={phoneImg} />
                    <Typography.Text style={{ fontWeight: "500" }}>{formatPhoneNumber(participant)}</Typography.Text>
                </Flex>
            )
        },
        {
            title: "Status",
            dataIndex: "status",
            align: "center",
            key: "status",
            render: (_, { status }) => <Tag color={status === "failed" ? "red" : "green"}>{status}</Tag>
        },
        {
            title: "Message",
            dataIndex: "body",
            align: "center",
            key: "body",
            render: (_, { body }) => (
                <Tooltip title={body}>
                    {" "}
                    <Typography.Text style={{ fontWeight: "500", cursor: "pointer" }}>{body}</Typography.Text>
                </Tooltip>
            )
        },
        {
            title: "Date and Time",
            dataIndex: "updated_at",
            align: "center",
            key: "updated_at",
            render: (_, { timestamp, scheduled_at, status }) => (
                <Typography.Text style={{ fontWeight: "500" }}>
                    {status === "scheduled" && scheduled_at ? (
                        <Flex gap={5}>
                            {dayjs(scheduled_at).format("MM/DD/YYYY h:mm A")}
                            <Popover content={<Typography.Text style={{ fontWeight: "500" }}>Scheduled</Typography.Text>}>
                                <FaCircleInfo color="#000" size={16} cursor={"pointer"} style={{ marginTop: "2px" }} />
                            </Popover>
                        </Flex>
                    ) : status === "delivered" && scheduled_at ? (
                        dayjs(scheduled_at).format("MM/DD/YYYY h:mm A")
                    ) : (
                        dayjs(timestamp).format("MM/DD/YYYY h:mm A")
                    )}{" "}
                </Typography.Text>
            )
        }
    ];
    const filteredData =
        data
            ?.filter(item => {
                if (!search) return true;

                if (
                    item.body.toLowerCase().includes(search.toLowerCase()) ||
                    item.participant.toLowerCase().includes(search.toLowerCase()) ||
                    item.status.toLowerCase().includes(search.toLowerCase())
                )
                    return true;
            })
            .sort((a, b) => {
                const statusOrder = ["sent", "failed", "pending"];
                return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
            }) || [];

    return (
        <div>
            <Table
                loading={isLoading}
                pagination={{
                    total: data?.length,
                    showTotal: total => `Total ${total} items`,
                    defaultPageSize: 20
                }}
                columns={columns}
                dataSource={[...filteredData]}
            />
        </div>
    );
};

export default BulkMessageStatusTable;
